// @mui material components
import Grid from "@mui/material/Grid";
import Divider from "@mui/material/Divider";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

// Overview page components
import Header from "layouts/profile/components/Header";

import ChangePasswordCard from "./components/ChangePasswordCard";
import API_CONFIG from "../../../config";
import axios from "axios";

function ChangePassword() {
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox mb={2} />
      <Header>
        <MDBox mt={5} mb={3}>
          <Grid container spacing={1}>
            <Grid item sx={{ display: "flex", width: "50%" }}>
              <Divider orientation="vertical" sx={{ ml: -2, mr: 1 }} />
              <ChangePasswordCard
                onChangePassword={(currentPassword, newPassword) => {
                  return new Promise((resolve, reject) => {
                    // Simulate API call with payload
                    const payload = {
                      oldPassword: currentPassword,
                      password: newPassword,
                      token: sessionStorage.getItem("authToken") || sessionStorage.getItem("token"),
                    };
                    axios
                      .post(`${API_CONFIG.BASE_URL}home/changepassword`, payload, {
                        headers: {
                          "Content-Type": "application/json",
                        },
                      })
                      .then((response) => {
                        resolve(response.data);
                      })
                      .catch((error) => {
                        reject(error);
                      });
                  });
                }}
              />
            </Grid>
          </Grid>
        </MDBox>
      </Header>
      <Footer />
    </DashboardLayout>
  );
}

export default ChangePassword;
